export default function Spinner({ label }) {
  if (!label) return <span className="s-spin" />;
  return (
    <div className="s-loading">
      <span className="s-spin" />
      {label}
    </div>
  );
}
